"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var unavailable_exports = {};
__export(unavailable_exports, {
  LocalAuthentication: () => LocalAuthentication
});
module.exports = __toCommonJS(unavailable_exports);
var import_nativeError = require("../nativeError");
var LocalAuthentication = Object.freeze({
  canEvaluatePolicy: function canEvaluatePolicy() {
    return {
      available: false,
      biometryType: "none"
    };
  },
  evaluatePolicy: function evaluatePolicy(_reason) {
    return Promise.reject((0, import_nativeError.missingNativeBuild)("LocalAuthentication.evaluatePolicy"));
  }
});
//# sourceMappingURL=unavailable.js.map
